import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { CatalogoService } from 'src/app/aplicaciones-modulos/distribuidores/services/catalogo.service';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import {
  LfsaBotonEditarGridComponent
} from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import { IndicadoresVivosVModel } from '../../models/indicadoresVivosVModel';
import { CatalogoIndicadoresService } from '../../services/catalogo-indicadores.service';
import { CargaInicialPromediosComisionService } from '../../services/carga-inicial-promedios-comision.service';
import { comisionesModulo } from '../../diccionarios/comisionesModulo';

@Component({
  selector: 'app-carga-inicial-promedios-comision',
  templateUrl: './carga-inicial-promedios-comision.component.html',
  styleUrls: ['./carga-inicial-promedios-comision.component.css']
})

export class CargaInicialPromediosComisionComponent implements OnInit {

  titulo = 'Carga Prom. y Cumplimiento de Incentivos';
  mostrarFormulario = false;

  textoBuscar = '';
  gridApi: any;
  gridColumnApi: any;
  columnDefs: any[];
  columnDefsCarteras: any[];
  frameworkComponents: any;
  rowSelection: any;
  rowData: any[] = [];

  @ViewChild('fileInput') fileInput: ElementRef;
  formulario: FormGroup;
  
  rowDataCarteras: any[] = [];

  loading: boolean = false;
  listaVacia: boolean = true;

  modulo: any = {};


  DAT_BTNS: any;
  DAT_MSG: any;
  DAT_BTNCSS: any;

  modelGrid: any;
  csv: string;
  objSelected: any = {};
  listaVaciaCli: boolean = true;
  errorData: boolean = true;
  cmbOpciones: { clave: number; valor: string; }[];

  constructor(
    public fb: FormBuilder,
    private _util: UtilsService,
    private catalogo: CatalogoService,
    private _serviciosCRUD: CargaInicialPromediosComisionService,
  ) { }

  ngOnInit() {

    this.formulario = this.fb.group({
      multipart: ['', [Validators.required]],
    });

    const innClase = new IndicadoresVivosVModel();
    this.modelGrid = innClase.devolverGriCargaInicialPromediosComision();

    this.modulo = comisionesModulo;
    this.DAT_BTNS = this.modulo.button.buttonsNombre;
    this.DAT_MSG = this.modulo.mensajes;
    this.DAT_BTNCSS = this.modulo.button.buttonsCss;
    this.cargarIconosFiltros();
    this.cargarGrid();
    this.cargarGridCarteras();

    this.formulario.get('multipart').valueChanges
      .subscribe((resp) => {
        this.getFormValidationErrors();
      });

    this.getTodo();

  }

  /** FUNCIONES */
  getTodo() {
    this.listaVacia = true;
    this.loading = true;

    this._serviciosCRUD.getTodo().subscribe((res: any[]) => {
      console.log("getTodo()", res)
      this.loading = false;
      this.listaVacia = (res.length === 0) ? true : false;
      this.rowDataCarteras = res;
    }, (err) => {
      this.loading = false;
      this.listaVacia = true;
      this.rowDataCarteras = [];
    });
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  onQuickFilterChanged() {
    this.gridApi.setQuickFilter(this.textoBuscar);
  }

  cargarIconosFiltros() {
    this.csv = this.catalogo.catalogoAsesorIcon().csv;
  }

  changeRowColor(params) {
    let data = params.data;
    if (data.correct != undefined) {
      if (data.correct === true) {
        return {
          'background-color': 'lightgreen',
          'color': 'black',
          'font-weight': 'bold',
          'font-size': '14px'
        };
      }
      else {
        return {
          'background-color': '#FFC0CB',
          'color': 'black',
          'font-weight': 'bold',
          'font-size': '14px'
        };
      }
    }
    return true;
  }

  cargarGrid() {
    this.frameworkComponents = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };

    this.columnDefs = [
      {
        headerName: 'ESTADO',
        sortable: true,
        filter: true,
        width: 180,
        cellStyle: this.changeRowColor.bind(this),
        valueGetter: function (params: any) {
          return (params.data.correct === true) ? 'CORRECTO' : 'INCORRECTO';
        }
      },
      {
        headerName: 'Código Vendedor',
        field: this.modelGrid.codigoVendedor,
        filter: true,
        width: 200,
        sortable: true
      },
      {
        headerName: 'Nombre Vendedor',
        field: this.modelGrid.nombreVendedor,
        filter: true,
        width: 350,
        sortable: true
      },
      {
        headerName: 'ID Variable',
        field: this.modelGrid.variableId,
        filter: true,
        width: 120,
        sortable: true
      },
      {
        headerName: 'Variable',
        field: this.modelGrid.variableDescripcion,
        filter: true,
        width: 350,
        sortable: true
      },
      {
        headerName: 'Promedio',
        field: this.modelGrid.promedio,
        filter: true,
        width: 100,
        sortable: true
      },
      {
        headerName: 'Año',
        field: this.modelGrid.anio,
        filter: true,
        width: 100,
        sortable: true
      },
      {
        headerName: 'Mes',
        field: this.modelGrid.mesDescripcion,
        filter: true,
        width: 150,
        sortable: true
      },
      {
        headerName: 'ERROR',
        field: 'error.errorCampo',
        cellStyle: this.changeRowColor.bind(this),
        filter: true,
        width: 600,
        sortable: true
      },
    ];
    this.rowSelection = 'multiple';
  }

  regresar() {
    this.mostrarFormulario = false;
    this.rowData = [];
    this.formulario.reset();
  }

  onFileSelect(event) {
    let allowedExtensions = /(.csv)$/i;
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      if (!allowedExtensions.exec(file.name)) {
        this.formulario.get('multipart').setValue('');
        this._util.mensajeErrorVisto('El tipo de archivo no es valido, el tipo de archivo permitido es "CSV" ', true, 9000);
        this.fileInput.nativeElement.value = '';
      } else {
        this.formulario.get('multipart').setValue(file);
      }
    }
  }

  setFormData(data: any): FormData {
    const formData = new FormData();
    formData.append('file', new Blob([data.multipart], { type: 'text/csv' }), 'file');
    return formData;
  }

  validarRowData() {
    this.errorData = true;
    this.rowData.forEach(e => {
      if (e.correct) {
        this.errorData = false;
      }
    });
  }

  enviarFormulario() {
    this._util.confirmarSincronoPromesaNormal(
      {
        title: 'Esta seguro que desea enviar el siguiente archivo?',
        text: '',
        action: 'Enviar',
        funcion: this._serviciosCRUD.procesarCsv(this.setFormData(this.formulario.value)),
        loading: true,
        context: this,
      }
    ).then((res: any[]) => {
      console.log("enviarFormulario()", res);
      // debugger
      this.mostrarFormulario = true;
      this.rowData = res;
      if (this.rowData.length > 0) {
        this.listaVacia = false;
        this.validarRowData();
      } else {
        this.listaVacia = true;
      }
    }).catch((err) => {
      console.log('Error ' + err);
      this.rowData = [];
      this.listaVacia = true;
    });
  }

  guardar() {
    this._util.confirmarSincronoPromesaNormal(
      {
        title: 'Esta seguro que desea guardar el siguiente listado?',
        text: '',
        action: 'Guardar',
        funcion: this._serviciosCRUD.saveCsv(this.rowData),
        loading: true,
        context: this,
      }
    ).then((res: any) => {
      this.getTodo();
      this._util.mensajeOKVisto(res, true, 10000);
      this.downloadDataCsv();
      this.regresar();
    }).catch((err) => {
      console.log('Error ' + err);
      this._util.mensajeErrorVisto(err.error.message, true, 3000);
    });
  }

  downloadCsvFormato() {
    let cabecera: any[] = [['COD. VENDEDOR', 'ID VARIABLE', 'PROMEDIO', 'AÑO', 'MES']];
    const data: any[] = [
      { 'vendedorId': '400000232', 'variableId': '20', 'promedio': 3, 'anio': 2023, 'mes': 10 }
    ];
    let name: string = "formato-plantilla.csv";
    this._util.exportCSV(cabecera, data, name);
  }

  downloadDataCsv() {
    let data: any = [];
    let cabecera: any[] = [['COD. VENDEDOR', 'PROMEDIO', 'AÑO', 'MES', 'Estado', 'Linea', 'Error']];
    let clonData = this.rowData.map((x) => Object.assign({}, x));
    clonData.forEach((e) => {
      if (!e.correct) {
        data.push(
          {
            idPromedio: e.idPromedio ? e.idPromedio : '',
            anio: e.anio ? e.anio : '',
            mes: e.mes ? e.mes : '',
            codigoVendedor: e.codigoVendedor ? e.codigoVendedor : '',
            promedio: e.promedio ? e.promedio : '',
            nombreVendedor: e.nombreVendedor ? e.nombreVendedor : '',
            mesDescripcion: e.mesDescripcion ? e.mesDescripcion : '',
            estado: (e.correct) ? 'CORRECTO' : 'INCORRECTO',
            linea: (e.error === undefined) ? '' : e.error.linea,
            errorCampo: (e.error === undefined) ? '' : e.error.errorCampo,
          }
        );
      }
    });
    let name: string = "REGISTRO_ERRORES.csv";
    this._util.exportCSV(cabecera, data, name);
    // this._util.mensajeOKToast('El archivo csv se exporto correctame.');
  }

  setCodigoArticulo({ codigoArticulo, contenedor }) {
    if (codigoArticulo !== undefined && contenedor !== undefined && contenedor !== "") {
      return `${codigoArticulo}/${contenedor}`
    } else {
      if (codigoArticulo !== undefined) {
        return `${codigoArticulo}`;
      } else {
        return '';
      }
    }
  }

  getFormValidationErrors() {

    console.log('%c ==>> Validation Errors: ', 'color: red; font-weight: bold; font-size:25px;');

    let totalErrors = 0;

    Object.keys(this.formulario.controls).forEach(key => {
      const controlErrors: ValidationErrors = this.formulario.get(key).errors;
      if (controlErrors != null) {
        totalErrors++;
        Object.keys(controlErrors).forEach(keyError => {
          console.log('Key control: ' + key + ', keyError: ' + keyError + ', err value: ', controlErrors[keyError]);
        });
      }
    });

    console.log('Number of errors: ', totalErrors);
  }

  cargarGridCarteras() {
    this.frameworkComponents = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };
    this.columnDefsCarteras = [
      {
        headerName: 'Id',
        field: 'idMetasIncentivo',
        filter: true,
        sortable: true,
        width: 50,
        // cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Año',
        field: 'anio',
        sortable: true,
        width: 100,
        filter: true,
        // cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Mes',
        field: 'mesDescripcion',
        sortable: true,
        width: 160,
        filter: true,
        // cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Vendedor',
        field: 'codigoSap',
        sortable: true,
        width: 200,
        filter: true,
        // cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Nombre Vendedor',
        field: 'nombreVendedor',
        sortable: true,
        width: 350,
        filter: true,
        // cellStyle: this.changeCellColor.bind(this),
      }, {
        headerName: 'Promedio',
        field: 'promedio',
        sortable: true,
        width: 100,
        filter: true,
        // cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Variable',
        field: 'variableDescripcion',
        sortable: true,
        width: 350,
        filter: true,
        // cellStyle: this.changeCellColor.bind(this),
      },
      // {
      //   headerName: '',
      //   cellRenderer: 'buttonRenderer',
      //   width: 150,
      //   cellRendererParams: {
      //     onClick: this.editar.bind(this),
      //     label: this.DAT_BTNS.editar,
      //     colorBoton: this.DAT_BTNCSS.warning
      //   }
      // },
      // {
      //   headerName: '',
      //   cellRenderer: 'buttonRenderer',
      //   width: 150,
      //   cellRendererParams: {
      //     onClick: this.eliminar.bind(this),
      //     label: this.DAT_BTNS.eliminar,
      //     colorBoton: this.DAT_BTNCSS.danger
      //   }
      // },
    ];

    this.rowSelection = 'multiple';
  }

}
